<script>
	import client from "../../services/client";
	import { loading, errorMessage, editFuelcardData } from "../../store/store";
	import { onMount } from "svelte";
	import CreateFuelCardForm from "./CreateFuelCardForm.svelte";
	import LoaderContainer from "../../components/Loader/LoaderContainer.svelte";
	import { extractErrorMessage } from "../../utils/misc";

	const params = new Proxy(new URLSearchParams(window.location.search), {
		get: (searchParams, prop) => searchParams.get(prop),
	});

	onMount(async () => {
		loading.set(true);
		try {
			const resDetail = await client(`/v1/fuel/cards/${params.id}`, {
				method: "GET",
				version: "Vehicle",
			});

			editFuelcardData.set(resDetail.data);
			loading.set(false);
		} catch (error) {
			loading.set(false);
			console.log(error.response);
			extractErrorMessage(error);
		}
	});
</script>

{#if !$editFuelcardData.fuelCompanyId || !$editFuelcardData}
	<LoaderContainer>
		<CreateFuelCardForm />
	</LoaderContainer>
{:else}
	<CreateFuelCardForm fuelCardId={params.id} />
{/if}
